<template>
  <div>
    <div class="item-text item-price" v-if="!finalSalePrice">
      <span v-html="finalBasicPrice"> </span>
    </div>
    <div class="item-text item-price reduced-price" v-else>
      <div class="old-price">
        <span v-html="finalBasicPrice"> </span>
      </div>
      <div class="new-price">
        <span v-html="finalSalePrice"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    "final-basic-price": "",
    "final-sale-price": "",
  },
};
</script>
